var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"register-login"},[_c('div',{staticClass:"container"},[_c('Header'),_c('FormLogin',{attrs:{"isAnalist":_vm.isAnalist}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }